<template>
  <div
    id="app"
    class="min-h-screen bg-[#030712] text-gray-100 relative overflow-x-hidden"
  >
    <div
      class="absolute inset-0 -z-20 bg-gradient-to-b from-[#030712] via-[#050b17] to-[#0b1120]"
    ></div>
    <div
      class="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-primary-500/15 to-transparent -z-10 blur-3xl"
    ></div>
    <!-- Navigation -->
    <nav
      v-if="isAuthenticated"
      class="fixed inset-x-0 top-0 z-20 bg-[#050b17]/90 backdrop-blur-xl border-b border-primary-500/20 shadow-lg"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex items-center">
            <router-link
              to="/dashboard"
              class="flex-shrink-0 flex items-center"
            >
              <!-- <div
                class="w-9 h-9 bg-gradient-to-br from-primary-400 to-primary-600 rounded-2xl flex items-center justify-center shadow-lg shadow-primary-900/30"
              >
                <span class="text-slate-950 font-bold text-sm">CM</span>
              </div>
              <span class="ml-3 text-lg font-semibold tracking-tight text-white"
                >Keal.club</span
              > -->
              <KealLogo class="w-32 h-auto" />
            </router-link>

            <div class="hidden md:ml-6 md:flex md:space-x-8">
              <router-link
                to="/dashboard"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'dashboard'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Dashboard
              </router-link>
              <router-link
                to="/approvals"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'approvals'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Guardrails
              </router-link>
              <router-link
                v-if="false"
                to="/onboarding"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'onboarding'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Setup
              </router-link>
              <router-link
                to="/rates"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'rates'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Rates
              </router-link>
              <router-link
                to="/analytics"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'analytics'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Analytics
              </router-link>
              <router-link
                to="/media"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'media'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Media
              </router-link>
              <router-link
                to="/generations"
                class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                :class="
                  currentRoute === 'generations'
                    ? 'border-primary-400 text-white'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-white/10'
                "
              >
                Generations
              </router-link>
            </div>
          </div>

          <div class="flex items-center gap-3">
            <!-- Desktop user section -->
            <div class="hidden md:flex items-center space-x-3">
              <BaseAvatar size="sm" src="/assets/images/messi.png" ring />
              <span class="text-sm text-gray-300">
                {{ userDisplayName }}
              </span>
              <BaseButton
                variant="secondary"
                size="xs"
                rounded
                @click="logout"
                class="text-xs"
              >
                Logout
              </BaseButton>
            </div>
            <!-- Mobile user section -->
            <div class="md:hidden flex items-center space-x-2">
              <BaseAvatar size="sm" src="/assets/images/messi.png" ring />
              <span class="text-sm text-gray-300">
                {{ userDisplayName }}
              </span>
            </div>
            <!-- Mobile menu button -->
            <button
              @click="mobileMenuOpen = !mobileMenuOpen"
              class="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            >
              <span class="sr-only">Open main menu</span>
              <!-- Hamburger icon -->
              <i v-if="!mobileMenuOpen" class="bi bi-list text-2xl"></i>
              <!-- Close icon -->
              <i v-else class="bi bi-x-lg text-2xl"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile menu panel -->
      <div v-if="mobileMenuOpen" class="md:hidden border-t border-gray-700">
        <div class="px-2 pt-2 pb-3 space-y-1">
          <router-link
            to="/dashboard"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'dashboard'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Dashboard
          </router-link>
          <router-link
            to="/approvals"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'approvals'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Guardrails
          </router-link>
          <router-link
            to="/rates"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'rates'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Rates
          </router-link>
          <router-link
            to="/analytics"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'analytics'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Analytics
          </router-link>
          <router-link
            to="/media"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'media'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Media
          </router-link>
          <router-link
            to="/generations"
            @click="mobileMenuOpen = false"
            class="block px-3 py-2 rounded-md text-base font-medium"
            :class="
              currentRoute === 'generations'
                ? 'bg-primary-500/20 text-white border-l-4 border-primary-400'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white'
            "
          >
            Generations
          </router-link>
        </div>
        <div class="pt-4 pb-3 border-t border-gray-700">
          <div class="flex items-center px-5">
            <BaseAvatar size="sm" src="/assets/images/messi.png" ring />
            <div class="ml-3">
              <div class="text-base font-medium text-white">{{ userDisplayName }}</div>
            </div>
          </div>
          <div class="mt-3 px-2">
            <BaseButton
              variant="secondary"
              size="sm"
              @click="logout"
              class="w-full"
            >
              Logout
            </BaseButton>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="flex-1 relative z-10" :class="{ 'pt-16': isAuthenticated }">
      <router-view />
    </main>

    <!-- Footer -->
    <footer
      v-if="!isAuthenticated"
      class="bg-[#050b17] border-t border-white/5 mt-auto"
    >
      <div class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex justify-center md:justify-start">
            <div class="flex-shrink-0 flex items-center">
              <div
                class="w-8 h-8 bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center shadow-md shadow-primary-900/30"
              >
                <span class="text-slate-950 font-bold text-xs">CM</span>
              </div>
              <span class="ml-3 text-lg font-semibold text-white"
                >Keal.club</span
              >
            </div>
          </div>
          <div class="mt-8 md:mt-0 md:order-1">
            <p class="text-center text-sm text-gray-400">
              &copy; 2024 Keal.club. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "./stores/auth";
import BaseButton from "@/components/BaseButton.vue";
import BaseAvatar from "@/components/BaseAvatar.vue";
import KealLogo from "./components/KealLogo.vue";

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const mobileMenuOpen = ref(false);

const isAuthenticated = computed(() => authStore.isAuthenticated);
const userProfile = computed(() => authStore.userProfile);

const userDisplayName = computed(() => {
  const profile = userProfile.value;
  return (
    profile?.profile?.displayName ||
    profile?.displayName ||
    profile?.email ||
    "Influencer"
  );
});

const currentRoute = computed(() => route.name);

onMounted(async () => {
  // Check if user is authenticated on app load
  if (localStorage.getItem("token")) {
    try {
      await authStore.fetchProfile();
    } catch (error) {
      // Token might be invalid, clear it
      authStore.logout();
    }
  }
});

const logout = () => {
  authStore.logout();
  router.push("/");
};
</script>

<style>
/* Global styles */
#app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  background-color: #05030b;
}

/* Smooth transitions for route changes */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

/* Custom scrollbar - subtle and dark-theme friendly */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35); /* slate-400/35 */
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.6);
}
</style>
